/**
 * Date utility functions
 */

import { format, parseISO } from 'date-fns';

export const formatDateForDisplay = (isoDate: string): string => {
  try {
    // Parse the ISO date string
    const dt = parseISO(isoDate.replace('Z', '+00:00'));
    // Format as "HH:MM Month DD, YYYY"
    return format(dt, 'HH:mm MMM dd, yyyy');
  } catch (error) {
    // Return original if parsing fails
    return isoDate;
  }
};

export const formatCompactDate = (isoDate: string): string => {
  try {
    const dt = parseISO(isoDate.replace('Z', '+00:00'));
    return format(dt, 'HH:mm MM/dd');
  } catch (error) {
    return isoDate.substring(0, 5);
  }
};

export const formatTableDate = (isoDate: string): string => {
  try {
    const dt = parseISO(isoDate.replace('Z', '+00:00'));
    return format(dt, 'MM/dd HH:mm');
  } catch (error) {
    return isoDate.substring(0, 10);
  }
};
